import { Controller } from '@hotwired/stimulus';

// Controller to auto-populate trade field based on selected contractor
export default class extends Controller {
  static targets = [
    'contractorSelect',
    'tradeSelect',
    'tradeInput',
    'noContractorHelp',
    'contractorSelectedHelp',
    'editContractorLink',
  ];

  connect() {
    this.updateTrades();
  }

  // Called when contractor selection changes
  updateTrades() {
    const selectedOption = this.contractorSelectTarget.selectedOptions[0];

    if (!selectedOption || !selectedOption.value) {
      // No contractor selected - disable and clear the trade input
      this.disableTradeFields();
      this.showTextInput();
      return;
    }

    // Get trades from data attribute
    const trades = JSON.parse(selectedOption.dataset.trades || '[]');

    // Enable trade fields since a contractor is now selected
    this.enableTradeFields();

    if (trades.length === 0) {
      // No trades - show text input (but keep it enabled)
      this.showTextInput();
    } else if (trades.length === 1) {
      // Only one trade - auto-fill and hide select
      this.tradeInputTarget.value = trades[0];
      this.showTextInput();
    } else {
      // Multiple trades - show select
      this.populateTradeSelect(trades);
      this.showSelect();
    }
  }

  // Disable trade fields when no contractor selected
  disableTradeFields() {
    this.tradeInputTarget.disabled = true;
    this.tradeSelectTarget.disabled = true;
    this.tradeInputTarget.value = ''; // Clear the value
    this.showNoContractorHelp();
  }

  // Enable trade fields when contractor is selected
  enableTradeFields() {
    this.tradeInputTarget.disabled = false;
    this.tradeSelectTarget.disabled = false;
    this.showContractorSelectedHelp();
    this.updateEditContractorLink();
  }

  // Show helper message when no contractor is selected
  showNoContractorHelp() {
    // Check if targets exist (they won't exist if there are validation errors)
    if (this.hasNoContractorHelpTarget && this.hasContractorSelectedHelpTarget) {
      this.noContractorHelpTarget.classList.remove('hidden');
      this.contractorSelectedHelpTarget.classList.add('hidden');
    }
  }

  // Show helper message when contractor is selected
  showContractorSelectedHelp() {
    if (this.hasNoContractorHelpTarget && this.hasContractorSelectedHelpTarget) {
      this.noContractorHelpTarget.classList.add('hidden');
      this.contractorSelectedHelpTarget.classList.remove('hidden');
    }
  }

  // Update the edit contractor link with the selected contractor ID
  updateEditContractorLink() {
    const contractorId = this.contractorSelectTarget.value;
    if (contractorId && this.hasEditContractorLinkTarget) {
      // Build the edit URL: /contractors/:id/edit
      this.editContractorLinkTarget.href = `/contractors/${contractorId}/edit`;
    }
  }

  populateTradeSelect(trades) {
    // Clear existing options except the prompt
    this.tradeSelectTarget.innerHTML = '<option value="">Sélectionner un métier</option>';

    // Add trade options
    trades.forEach((trade) => {
      const option = document.createElement('option');
      option.value = trade;
      option.textContent = trade;
      this.tradeSelectTarget.appendChild(option);
    });
  }

  // When trade is selected from dropdown, copy to hidden input
  tradeSelected() {
    this.tradeInputTarget.value = this.tradeSelectTarget.value;
  }

  showSelect() {
    this.tradeSelectTarget.classList.remove('hidden');
    this.tradeInputTarget.classList.add('hidden');
  }

  showTextInput() {
    this.tradeSelectTarget.classList.add('hidden');
    this.tradeInputTarget.classList.remove('hidden');
  }
}
